import { useQuery } from '@tanstack/react-query'
import { feedbackApi } from '@/lib/api'
import { formatDate } from '@/lib/utils'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { FileIcon, MessageSquare } from 'lucide-react'

/** 客户反馈列表：展示反馈内容、处理状态与关联附件信息。 */
export function FeedbackList({ clientId }: { clientId: string }) {
  const { data: response, isLoading } = useQuery({
    queryKey: ['feedback', clientId],
    queryFn: () => feedbackApi.getByClient(clientId)
  })

  const feedbacks = response?.data || []

  if (isLoading) return <div className="py-6 text-sm text-muted-foreground">加载反馈中...</div>

  return (
    <div className="grid gap-4">
      {feedbacks.map((item: any) => (
        <Card key={item.id}>
          <CardHeader className="pb-2">
            <div className="flex justify-between items-start">
              <div className="flex items-center space-x-2">
                <MessageSquare className="h-4 w-4 text-primary" />
                <CardTitle className="text-base">反馈 #{item.id.slice(0, 8)}</CardTitle>
              </div>
              <Badge variant={item.status === 'processed' ? 'default' : 'secondary'}>
                {item.status === 'pending' ? '待处理' : '已采纳'}
              </Badge>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-foreground mb-4 whitespace-pre-wrap">{item.content}</p>
            {item.fileKey && (
              <div className="flex items-center p-2 rounded border bg-muted/30 text-xs text-foreground">
                <FileIcon className="mr-2 h-3 w-3" />
                关联文件附件
              </div>
            )}
            <div className="mt-2 text-[10px] text-muted-foreground">
              提交时间: {formatDate(item.createdAt)}
            </div>
          </CardContent>
        </Card>
      ))}
      {feedbacks.length === 0 && (
        <div className="text-center py-12 border-2 border-dashed rounded-lg text-muted-foreground">
          暂无反馈记录
        </div>
      )}
    </div>
  )
}
